var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { updateDataFromCollection } from './utils';
const initialState = {
    data: [],
    count: 0,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
export const createPostBoardNote = createAsyncThunk('reduxPostBoardNotes/create', (postBoardNotes_1, _a) => __awaiter(void 0, [postBoardNotes_1, _a], void 0, function* (postBoardNotes, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.postBoardNotes.collection.create(postBoardNotes);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updatePostBoardNote = createAsyncThunk('reduxPostBoardNotes/update', (updatedPostBoards_1, _a) => __awaiter(void 0, [updatedPostBoards_1, _a], void 0, function* (updatedPostBoards, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.postBoardNotes.collection.update(updatedPostBoards);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const { actions, reducer } = createSlice({
    name: 'reduxPostBoardNotes',
    initialState,
    reducers: {
        setAllPostBoardNotes: (state, { payload }) => {
            state.data = payload;
        },
        createPostBoardNoteFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const t = [...state.data, updatedPayload];
            const newData = removeDuplicates(t, (note) => note.id);
            state.data = newData;
        },
        updatePostBoardNoteFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const newData = state.data.map((note) => {
                if (note.id === updatedPayload.id) {
                    return Object.assign(Object.assign({}, note), updatedPayload);
                }
                return note;
            });
            state.data = newData;
        },
        deletePostBoardNoteFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const newData = [...state.data].filter((note) => note.id !== updatedPayload.id);
            state.data = newData;
        },
    },
    extraReducers: (builder) => {
        // CREATE
        builder.addCase(createPostBoardNote.pending, (state, { payload }) => { });
        builder.addCase(createPostBoardNote.fulfilled, (state, { payload }) => {
            const newData = [...state.data, ...payload];
            state.data = newData;
        });
        builder.addCase(createPostBoardNote.rejected, (state, { payload }) => { });
        // UDPDATE
        builder.addCase(updatePostBoardNote.pending, (state, { payload }) => { });
        builder.addCase(updatePostBoardNote.fulfilled, (state, { payload }) => {
            const newData = updateDataFromCollection(state.data, payload);
            state.data = newData;
        });
        builder.addCase(updatePostBoardNote.rejected, (state, { payload }) => { });
    },
});
export const { setAllPostBoardNotes, createPostBoardNoteFromWS, updatePostBoardNoteFromWS, deletePostBoardNoteFromWS } = actions;
export default reducer;
